export default __webpack_public_path__ + "static/media/learn.1d967b35.svg";